import { Link } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { useSEO } from '@/lib/useSEO';
import { Compass, ArrowRight, LayoutGrid } from 'lucide-react';

/**
 * 404 page. Replaces the previous wildcard-to-Landing fallback so bogus URLs
 * are clearly signaled to both users and crawlers.
 */
export default function NotFound() {
  useSEO({
    title: '404 · Página no encontrada | AutoMarket Colombia',
    description: 'La página que buscas no existe o fue movida. Explora el catálogo de repuestos.',
  });

  return (
    <Layout>
      <div className="mx-auto max-w-2xl px-4 py-20 sm:px-6 lg:px-8 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center bg-slate-900 text-white">
          <Compass className="h-7 w-7" />
        </div>
        <div className="mt-6 text-xs font-bold uppercase tracking-[0.25em] text-orange-600">Error 404</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl font-black tracking-tighter text-slate-900">
          Esta ruta no existe
        </h1>
        <p className="mt-3 text-slate-600 max-w-lg mx-auto">
          Puede que el enlace esté roto o que el recurso haya sido movido. Prueba con nuestro catálogo
          o ve al inicio.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/catalogo"
            data-testid="notfound-catalog-cta"
            className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-400 text-slate-900 font-bold px-5 h-11 transition-colors"
          >
            <LayoutGrid className="h-4 w-4" /> Explorar catálogo <ArrowRight className="h-4 w-4" />
          </Link>
          <Link
            to="/"
            data-testid="notfound-home-cta"
            className="inline-flex items-center gap-2 border border-slate-300 hover:bg-slate-50 text-slate-900 font-bold px-5 h-11 transition-colors"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </Layout>
  );
}
